export interface EntityTagSnapshot {
  pkey?: string
  entity_type: string
  entity_pkey: string
  tags?: string[]
}

export interface RentalTagUpdate {
  id: string
  changes: { tags: string[] }
}

export function entityTagsToRentalUpdates(items: EntityTagSnapshot[]): RentalTagUpdate[] {
  const seen = new Set<string>()

  return items.reduce<RentalTagUpdate[]>((updates, item) => {
    if (item.entity_type !== 'rental' || seen.has(item.entity_pkey)) return updates

    // /tag/all is newest-first. Keep the first document for a rental so an
    // older duplicate cannot overwrite the authoritative snapshot in NgRx.
    seen.add(item.entity_pkey)
    updates.push({ id: item.entity_pkey, changes: { tags: [...(item.tags || [])] } })
    return updates
  }, [])
}

export function resolveSetEntityTagsOperation(
  tags: string[],
  entity?: Pick<EntityTagSnapshot, 'pkey' | 'tags'>
): 'skip' | 'upsert' {
  const current = entity ? entity.tags || [] : []
  const unchanged = current.every((tag) => tags.includes(tag)) && tags.every((tag) => current.includes(tag))
  return entity && entity.pkey && unchanged ? 'skip' : 'upsert'
}
